import { CHAT_CAMPAIGN_OPEN_ANALYZING_SUGGESTIONS } from "../../i18n/keysTranslations";

/** Matches chat.css openingAssistHeartbeat: 3.4s × 2 pulses + 0.35s delay */
export const OPENING_ASSIST_HIGHLIGHT_MS = 7600;

export const OPENING_ASSIST_EMPTY_PLACEHOLDER = {
  ANALYZING: "analyzing",
};

export const OPENING_ASSIST_SYNTHETIC_MESSAGE_ID =
  "__openingAssistPlaceholder__";

export const getOpeningAssistEmptyPlaceholderMessageKeys = (placeholder) => {
  if (placeholder === OPENING_ASSIST_EMPTY_PLACEHOLDER.ANALYZING) {
    return [CHAT_CAMPAIGN_OPEN_ANALYZING_SUGGESTIONS];
  }

  return null;
};
